<template>
  <div style="position: relative;">
    <gmaps-map :options="mapOptions" :style="mapStyle" :zoom="10">
      <gmaps-marker
        :key="index"
        :options="getMarkerPosition(marker)"
        v-for="(marker, index) in markers"
        @click="toggleInfoWindow(index)"
      />

      <!-- Polylines removidas para não poluir o mapa de consulta -->
      <!-- <gmaps-polyline
        :path="getCoordenadas(rdv.id)"
        strokeColor="blue"
        v-for="(rdv, idx) in rodovias"
        :key="'$rdv' - idx"
      /> -->
      <gmaps-info-window :options="infoOptions" ref="infoW" v-if="infoWinOpen == true" @closed="clearInfoWindow()" />
    </gmaps-map>
  </div>
</template>

<script lang="js">
import { gmapsMap, gmapsMarker, gmapsInfoWindow } from 'x5-gmaps'

export default {
  name: 'mapas',
  components: { 
    gmapsMap,
    gmapsMarker,
    gmapsInfoWindow
  },
  bodyClass: 'mapas-page',
  props: {
    demandas: Array,
    demanda: Object,
    kmlData: Array,
    coordenadas: Array,
    rodovias: Array
  },
  data() {
    return {
      infoOptions: {
        content: '',
        //optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: -10,
          height: -35
        }
      },
      infoWinOpen: false,
      infoWindowPos: null,
      mapOptions: {
        center: {
          lat: -23.550278,
          lng: -46.633889
        },
        zoom: 8, // Zoom mais amplo para consulta
        zoomControl: true,
        mapTypeControl: true,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false,
        styles: [
          // Estilo mais limpo para consulta
          {
            featureType: "poi",
            elementType: "labels",
            stylers: [{ visibility: "off" }]
          }
        ]
      },
      mapHeight: 600,
      mapWidth: 400,
      mapStyle: 'width: 99%; height: 500px;',
      markers: []
    }
  },
  mounted() {
    var w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    var h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

    this.mapWidth = w - 40;
    this.mapHeight = h - 20;

    this.mapStyle = 'width: 99%; height:' + this.mapHeight + 'px';

    if (this.demandas !== undefined) {
      for(const demanda of this.demandas ) {
        this.makeMarker(demanda);
      }
    } else if (this.demanda !== undefined) {
        this.makeMarker(this.demanda);
    }

    if (this.markers!= null && this.markers.length > 0) {
      this.mapOptions.center.lat = this.markers[0].position.lat;
      this.mapOptions.center.lng = this.markers[0].position.lng;
    }
  },
  methods: {
    getDemandaUrl(demanda) {
      const ctxPath = window.location.pathname.substring(0, window.location.pathname.indexOf("/", 2));
      return ctxPath + '/demanda/' + demanda.id.idDemanda;
    },
    getMarkerPosition(marker) {
      const obj = {
        position: {
          lat: parseFloat(marker.position.lat),
          lng: parseFloat(marker.position.lng)
        },
        title: marker.titulo
      };

      return obj;
    },
    makeMarker(demanda) {
      // Capturar informações da rodovia
      let rodoviaDesc = "Rodovia não informada";
      let kmInfo = "";
      
      // Tentar diferentes caminhos para encontrar a rodovia
      if (demanda.trecho && demanda.trecho.rodovia && demanda.trecho.rodovia.descricao) {
        rodoviaDesc = demanda.trecho.rodovia.descricao;
      } else if (demanda.rodovia && demanda.rodovia.descricao) {
        rodoviaDesc = demanda.rodovia.descricao;
      } else if (demanda.trecho && demanda.trecho.descricao) {
        rodoviaDesc = demanda.trecho.descricao;
      }

      // Capturar informações de KM
      if (demanda.kmInicial !== undefined && demanda.kmFinal !== undefined) {
        kmInfo = `KM ${demanda.kmInicial} ao KM ${demanda.kmFinal}`;
      } else if (demanda.kmInicial !== undefined) {
        kmInfo = `KM ${demanda.kmInicial}`;
      } else if (demanda.kmFinal !== undefined) {
        kmInfo = `KM ${demanda.kmFinal}`;
      }

      // Capturar status
      let statusInfoDesc = "Status não informado";
      if (demanda.statusInfo && demanda.statusInfo.descricao) {
        statusInfoDesc = demanda.statusInfo.descricao;
      } else if (demanda.status && demanda.status.descricao) {
        statusInfoDesc = demanda.status.descricao;
      }

      // Capturar cidade se disponível
      let cidadeInfo = "";
      if (demanda.cidade && demanda.cidade.descricao) {
        cidadeInfo = demanda.cidade.descricao;
      }

      // Card de mapa
      const infoText = `
        <div style="font-family: Arial, sans-serif; max-width: 350px; padding: 8px;">
          <h3 style="margin: 0 0 12px 0; color: #1e3a8a; font-size: 16px; font-weight: bold;">
            <a href="${this.getDemandaUrl(demanda)}" style="color: #1e3a8a; text-decoration: none;">
              ${demanda.titulo || 'Demanda sem título'}
            </a>
          </h3>
          <div style="font-size: 14px; color: #555; line-height: 1.6;">
            <div style="margin-bottom: 8px;">
              <span style="font-weight: bold;">Rodovia:</span> ${rodoviaDesc}
            </div>
            ${kmInfo ? `<div style="margin-bottom: 8px;"><span style="font-weight: bold;">Localização:</span> ${kmInfo}</div>` : ''}
            ${cidadeInfo ? `<div style="margin-bottom: 8px;"><span style="font-weight: bold;">Cidade:</span> ${cidadeInfo}</div>` : ''}
            <div style="margin-bottom: 8px;">
              <span style="font-weight: bold;">Status:</span> ${statusInfoDesc}
            </div>
          </div>
        </div>
      `;

      if (demanda.latitudeInicial !== undefined) {
        this.markers.push({
          position: { lat: demanda.latitudeInicial, lng: demanda.longitudeInicial },
          titulo: demanda.titulo || 'Demanda sem título',
          infoText: infoText
        });
      } else if (demanda.latitudeFinal !== undefined) {
        this.markers.push({
          position: { lat: demanda.latitudeFinal, lng: demanda.longitudeFinal },
          titulo: demanda.titulo || 'Demanda sem título',
          infoText: infoText
          });
      }
    },
    clearInfoWindow() {
      this.infoOptions.title = undefined;
      this.infoOptions.content = null;
      this.infoOptions.position = undefined;
      this.infoWinOpen = false;
    },
    toggleInfoWindow(index) {
      this.infoOptions.title = this.markers[index].titulo;
      this.infoOptions.content= this.markers[index].infoText;
      this.infoOptions.position = this.markers[index].position;
      this.infoWinOpen = true;
    },
  }
}
</script>